/**
* Accordion Module
**/

VP = window.VP || {};

(function( $ ) {
	VP.accordionModule = {
		active: null,
		content: null,
		obj: $('.vp-accordion'),
		trigger: $('.vp-accordion__title'),

		init: function () {
			var _this = this;
			_this.eventHandlers();
		},

		eventHandlers: function() {
			var _this = this;

			// Handles accordion item events

			_this.trigger.click(function(e) {
				e.preventDefault();
				_this.active = $(this).parent('li');
				_this.content = $(this).siblings('.vp-accordion__content');
				_this.current = $(this).parent('li').siblings('.vp-accordion__item--open').index();

				if( !_this.active.hasClass('vp-accordion__item--open') ) {
					_this.open(_this.current);
				} else {
					_this.close();
				}
			});
		},

		open: function(currentIndex) {
			var _this = this;
			var $parent = _this.active.parents('.vp-accordion').first();
			var $goTo = null;
			_this.close();

			var _top = 0;

			// Wait for the scroll animation to finish before opening the item.
			setTimeout(function() {
				// Get the position of the item before the active item
				if( _this.active.index() === 0 ) {
					$goTo = $parent;
					$goToQuicklinks = $('.quicklinks').outerHeight();
					_top = $goTo.offset().top - ( $('.vp-header').outerHeight() + ( $goToQuicklinks + 40 ) );
				} else {
					$goTo = $('.vp-accordion__item:eq('+(_this.active.index()-1)+')', $parent);
					_top = $goTo.offset().top - $('.vp-header').outerHeight();
				}

				// Scroll the document at the top of the active item
				$("html, body").animate({ scrollTop: _top + "px" }, 200);

				_this.active.addClass('vp-accordion__item--open');
				_this.content.stop().slideDown(300, function() {
					// update reveal metrics since position of elements have changed
					VP.reveal.updatePosition();
				});
			}, 200);
		},

		close: function() {
			var _this = this;
			var $parent = _this.active.parents('.vp-accordion').first();
			$('.vp-accordion__content', $parent).stop().slideUp(300, function() {
				VP.reveal.updatePosition();
			});
			$('.vp-accordion__item', $parent).removeClass('vp-accordion__item--open');
		}
	};
})(jQuery);
